import React, { useEffect } from "react";
import { ContainerCupom } from "./styles";
import { Input } from "../../Input";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { percentageMask } from "../../../services/Masks";
import { unmaskPercentage, unmaskToNumbers } from "../../../services/Unmasks";
import { cupomMask } from "../../../services/Masks";
import { Toggle } from "../../Toggle/Toggle";
import moment from "moment";
import { currencyMask } from "../../../services/Masks";
interface CupomType {
  cupom: string;
  desconto: number;
  tipo_desconto?: "porcentagem" | "valor";
  quantidadeUso?: number;
  dataExpiracao?: string;
  quantidadeLimite?: number;
  minimo_sacola?: number;
}

interface CupomProps {
  setCupom: (cupom: CupomType) => void;
  cupom: CupomType;
  excluirCupom?: () => void;
}

const Cupom: React.FC<CupomProps> = ({ setCupom, cupom, excluirCupom }) => {
  const { theme } = useTheme();
  useEffect(() => {
    const novoCupom = { ...cupom };

    if (!novoCupom.tipo_desconto) {
      novoCupom.tipo_desconto = "porcentagem";
    }

    if (
      novoCupom.tipo_desconto !== cupom.tipo_desconto ||
      novoCupom.dataExpiracao !== cupom.dataExpiracao ||
      novoCupom.quantidadeLimite !== cupom.quantidadeLimite
    ) {
      setCupom(novoCupom);
    }
  }, [cupom, setCupom]);

  return (
    <ContainerCupom configIn={"configuracoes"} theme={theme}>
      {
        
        <div className="containerCupom">
          <div className="inputContainer">
            <div className="flex tipoDescontoToggle">
              <Input
                type="text"
                value={cupom.cupom}
                placeholder="Nome do Cupom"
                required={true}
                mask={{
                  mask: cupomMask,
                }}
                maxLength={12}
                onChange={(newValue) => {
                  setCupom({ ...cupom, cupom: newValue });
                }}
                label="Nome do Cupom"
              />
              <label className="tipoDescontoLabel fonteTexto">
                Tipo de Desconto
              </label>
              <div className="tipoDescontoRadios">
                <label>
                  <Input
                    className="radioPorcentagem"
                    type="radio"
                    name="tipoDesconto"
                    value="porcentagem"
                    checked={cupom.tipo_desconto !== "valor"}
                    onChange={() =>
                      setCupom({ ...cupom, tipo_desconto: "porcentagem", desconto: 0 })
                    }
                    placeholder="Porcentagem (%)"
                    label="Porcentagem (%)"
                  />
                </label>
                <label>
                  <Input
                    className="radioValorFixo"
                    type="radio"
                    name="tipoDesconto"
                    value="valor"
                    checked={cupom.tipo_desconto === "valor"}
                    onChange={() =>
                      setCupom({ ...cupom, tipo_desconto: "valor", desconto: 0 })
                    }
                    placeholder="Valor Fixo (R$)"
                    label="Valor Fixo (R$)"
                  />
                </label>
              </div>
              <div className="flex-valorMin">            
              <Input
                  type="text"
                  value={cupom.desconto.toString()}
                  mask={{
                    mask: cupom.tipo_desconto === "valor" ? currencyMask : percentageMask,
                    unmask: cupom.tipo_desconto === "valor" ? unmaskToNumbers : unmaskPercentage,
                  }}
                  placeholder={
                    cupom.tipo_desconto === "valor"
                    ? "Valor de Desconto"
                    : "Porcentagem de Desconto"
                  }
                  required={true}
                  onChange={(newValue) => {
                    setCupom({
                      ...cupom,
                      // o unmaskPercentage transforma "0" em "", que virava NaN
                      desconto: newValue === "" ? 0 : parseFloat(newValue),
                    });
                  }}
                  label={cupom.tipo_desconto === "valor" ? "Desconto (R$)" : "Desconto (%)"}
                  />
                  <Input
                    type={"text"}
                    mask={{
                      mask: currencyMask,
                      unmask: unmaskToNumbers,
                    }}
                    value={
                      cupom.minimo_sacola &&
                      Number.parseFloat(cupom.minimo_sacola.toString()) > 0
                        ? cupom.minimo_sacola.toString()
                        : "0"
                    }                
                    placeholder={"R$100,00"}
                    required={false}
                    onChange={(newValue) => {
                      setCupom({
                        ...cupom,
                        minimo_sacola: newValue === "" ? 0 : parseFloat(newValue),
                      });
                    }}
                    label="Valor mínimo da sacola"
                  />
            </div>
          </div>
            <div className="configuracoesAvancadas">
              <div className="agendarExpiracao fonteTexto">
                <label>
                  <Toggle
                    value={cupom.dataExpiracao !== undefined && cupom.dataExpiracao !== null}
                    onChange={(newValue) => {
                      setCupom({
                        ...cupom,
                        dataExpiracao: newValue ? new Date().toISOString() : undefined,
                      });
                    }}
                  />
                  Agendar data de expiração
                </label>
                <div className={`flex expiracao ${cupom.dataExpiracao ? "ativo" : ""}`}>
                  {cupom.dataExpiracao && (
                    <Input
                      type="datetime-local"
                      disabled={!cupom.dataExpiracao}
                      value={moment(cupom.dataExpiracao).format("YYYY-MM-DDTHH:mm")}
                      placeholder="2023-04-27 11:28:00"
                      onChange={(newValue) => {
                        setCupom({
                          ...cupom,
                          dataExpiracao: moment(
                            newValue,
                            "YYYY-MM-DDTHH:mm:ss"
                          ).format("YYYY-MM-DD HH:mm"),
                        });
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="limitarUso fonteTexto">
                <label>  
                  <Toggle
                    value={(cupom.quantidadeLimite !== undefined && cupom.quantidadeLimite !== null) || cupom.quantidadeLimite === 0}
                    onChange={(newValue) => {
                      setCupom({
                        ...cupom,
                        quantidadeLimite: newValue ? 1 : undefined,
                      });
                    }}
                  />
                  Limitar quantidade de uso
                </label>
                <div className={`flex expiracao ${cupom.quantidadeLimite !== undefined && cupom.quantidadeLimite !== null ? "ativo" : ""}`}>
                  {cupom.quantidadeLimite !== undefined && cupom.quantidadeLimite >= 0 && (
                    <Input
                      type="number"
                      value={cupom.quantidadeLimite !== null && cupom.quantidadeLimite !== undefined
                        ? cupom.quantidadeLimite.toString()
                        : ''
                      }
                      placeholder="00"
                      onChange={(newValue) => {
                        setCupom({
                          ...cupom,
                          quantidadeLimite: newValue === '' ? 0 : parseInt(newValue),
                        });
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* ajustar depois para inativar, não excluir
          <div className="exclusao fonteTexto">
            <span
              onClick={() => {
                if (excluirCupom) {
                  excluirCupom();
                }
              }}
            >
              Excluir Cupom
            </span>
          </div> */} 
        </div>
      }
    </ContainerCupom>
  );
};

export default Cupom;
